module.exports = __webpack_public_path__ + "static/dog-traininer-f40fb5ba68bed241e44cc4367de35719.png";